import { useEffect, useState } from "react";
import RechargeCardView from "./view";
import { useNavigate } from "react-router-dom";
import { ReducersTypes } from "@/redux/reducers/Models";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerData, ID_PAYMENT_TYPE, paymentSavedCard } from "@/redux/ducks/customer";
import useCybersourceService from "@/hooks/useCybersourceService";

export default function RechargeCard() {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);

  const { addCyberSourceScripts, getSessionId } = useCybersourceService();
  
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [activeCard, setActiveCard] = useState(0);

  const goBack = () => {
    navigate("/payment");
  }

  const getCreditCard = () => {
    if (String(customer?.account?.idPaymentType) !== ID_PAYMENT_TYPE.IS_CARD) return null;

    return customer?.account?.card?.cardNumber;
  }

  const handleCard = (success: boolean) => {
    setIsLoading(false);

    if (!success) {
      setError(true);
      return;
    }

    dispatch(
      getCustomerData()
    );

    navigate("/payment/finished");
  }

  const recharge = () => {
    if (isLoading) return;
    
    if ((activeCard === 0 && !getCreditCard()) || activeCard === 1) {
      navigate("/payment/creditCard");
      return;
    }

    if (activeCard === 0) {
      setIsLoading(true);
      setError(false);

      const visitorId = getSessionId();

      dispatch(
        paymentSavedCard({
          visitorId: visitorId!,
          callback: handleCard,
        })
      );
    }
  }

  useEffect(() => {
    addCyberSourceScripts();
  }, []);

  return (
    <RechargeCardView
      isLoading={isLoading}
      goBack={goBack}
      payment={recharge}
      activeCard={activeCard}
      onChangeCard={setActiveCard}
      creditCard={getCreditCard()}
      error={error}
      setError={setError}
    />
  );
}
